import React, { useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  FormInput,
  FormTextarea,
  Button,
  Row,
  Col,
  Container,
  FormFeedback,
  Breadcrumb,
  BreadcrumbItem,
  FormCheckbox,
} from "shards-react";

import styled from "styled-components";
import { useFormik } from "formik";

import MenuBar from "shared/components/MenuBar/MenuBar";
import Layout from "shared/container/Layout";
import useToken from "shared/hook/useToken";
import useCurrentUser from "shared/hook/useCurrentUser";
import {
  SelectAgency,
  SelectagencyType,
  SelectTypeUser,
} from "shared/components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import getUser  from "shared/utils/getUser";
import baseUrl from "config/baseUrl";

const axios = require("axios").default;

const UserProfilePage = styled.div`
  height: calc(100vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
`;
const UserProfileFooter = styled.div`
  padding: 30px 0;
  border-top: 1px solid #e0e0e0;
`;
const StyledBreadcrumb = styled(Breadcrumb)`
  .breadcrumb {
    padding: 0 !important;
  }
`;
const Link = styled.a`
  color: ${(props) => props.color || "#000"};
  display: block;
  cursor: pointer;
  :hover {
    color: ${(props) => props.color || "#000"};
    text-decoration: none;
  }
`;
const AdminUserCreate = (props) => {
  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = "กรุณาระบุชื่อผู้ใช้งาน";
    }
    if (!values.password) {
      errors.password = "กรุณาระบุรหัสผ่าน";
    }
    if (!values.confirmpassword) {
      errors.confirmpassword = "กรุณาระบุยืนยันรหัสผ่าน";
    } else if (values.password !== values.confirmpassword) {
      errors.confirmpassword = "รหัสผ่านไม่ตรงกัน";
    }
    if (!values.firstName) {
      errors.firstName = "กรุณาระบุชื่อ";
    }
    if (!values.lastName) {
      errors.lastName = "กรุณาระบุนามสกุล";
    }
    if (!values.email) {
      errors.email = "กรุณาระบุอีเมล";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }
    if (!values.phone) {
      errors.phone = "กรุณาระบุเบอร์ติดต่อ";
    } else if (values.phone.length < 10) {
      errors.phone = "กรุณาระบุเบอร์ติดต่อให้ถูกต้อง";
    }
    if (!values.agencyId) {
      errors.agencyId = "กรุณาระบุชื่อหน่วยงาน";
    } else if (values.agencyId === "0") {
      errors.agencyId = "กรุณาระบุชื่อหน่วยงาน";
    }
    if (values.agencyId === "32" && !values.agencyName) {
      errors.agencyName = "กรุณาระบุชื่อหน่วยงาน";
    }
    if (!values.positionName) {
      errors.positionName = "กรุณาระบุตำแหน่ง";
    }
    if (!values.agencyTypeId) {
      errors.agencyTypeId = "กรุณารเลือกประเภทหน่วยงานของท่าน";
    } else if (values.agencyTypeId === "0") {
      errors.agencyTypeId = "กรุณารเลือกประเภทหน่วยงานของท่าน";
    }
    if (!values.userType) {
      errors.userType = "กรุณารเลือกประเภทผู้ใช้งาน";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      confirmpassword: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      agencyTypeId: "0",
      agencyId: "",
      positionName: "",
      agencyType: "",
      agencyName: "",
      userType: "",
      purposeAccessingSystem: "",
      userStatus: 1,
    },
    validate,
    onSubmit: (values) => {
      delete values.confirmpassword;
      axios
        .post(`${baseUrl}/v1/user/create`, values)
        .then(function(response) {
          showNotify("สร้างบัญชีผู้ใช้เรียบร้อยเรียบร้อย");
          setTimeout(() => {
            window.location = `/administrator/users/detail/${response.data.userId}`;
          }, 2000);
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.message) {
            showNotify(error.response.data.message, "error");
          } else {
            showNotify(error.message, "error");
          }
        });
    },
  });

  return (
    <>
      <Container>
        <ToastContainer />
        {/* <MenuBar path={location} title="การจัดการข้อมูลส่วนตัว" /> */}
        <Form onSubmit={formik.handleSubmit}>
          <UserProfilePage>
            <Row>
              <Col>
                <StyledBreadcrumb>
                  <BreadcrumbItem>
                    <a
                      href="/administrator/users"
                      style={{ color: "#8D8D8D" }}
                    >{`< กลับ`}</a>
                  </BreadcrumbItem>
                </StyledBreadcrumb>
              </Col>
            </Row>
            <h6 className="bold ">เพิ่มผู้ใช้งาน</h6>
            <h6 className="bold ">ข้อมูลการเข้าสู่ระบบ</h6>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>
                    ชื่อผู้ใช้งาน<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    name="username"
                    placeholder="ชื่อผู้ใช้งาน"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.username}
                    value={formik.values.username}
                  />
                  {formik.errors.username && (
                    <FormFeedback>{formik.errors.username}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>ประเภทผู้ใช้งาน</label>
                  <SelectTypeUser
                    placeholder="เลือก"
                    name="userType"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.userType}
                    value={formik.values.userType}
                  />
                  {formik.errors.userType && (
                    <FormFeedback>{formik.errors.userType}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup className="mt-2">
                  <label>สถานะผู้ใช้งาน</label>
                  <FormCheckbox
                    toggle
                    checked={formik.values.userStatus === 2 ? true : false}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "userStatus",
                        formik.values.userStatus === 2 ? 1 : 2
                      )
                    }
                  >
                    {formik.values.userStatus === 2 ? "เปิด" : "ปิด"}
                  </FormCheckbox>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <FormGroup>
                  <label>
                    รหัสผ่าน<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="password"
                    name="password"
                    placeholder="รหัสผ่าน"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.password}
                    value={formik.values.password}
                  />
                  {formik.errors.password && (
                    <FormFeedback>{formik.errors.password}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <label>
                    ยืนยันรหัสผ่าน<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="password"
                    name="confirmpassword"
                    placeholder="ยืนยันรหัสผ่าน"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.confirmpassword}
                    value={formik.values.confirmpassword}
                  />
                  {formik.errors.confirmpassword && (
                    <FormFeedback>{formik.errors.confirmpassword}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <h6 className="bold  mt-4">ข้อมูลส่วนตัว</h6>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>
                    ชื่อ<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    placeholder="ชื่อ"
                    name="firstName"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.firstName}
                    value={formik.values.firstName}
                  />
                  {formik.errors.firstName && (
                    <FormFeedback>{formik.errors.firstName}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>
                    นามสกุล<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    placeholder="นามสกุล"
                    name="lastName"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.lastName}
                    value={formik.values.lastName}
                  />
                  {formik.errors.lastName && (
                    <FormFeedback>{formik.errors.lastName}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>
                    เบอร์ติดต่อ<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="tel"
                    name="phone"
                    placeholder="เบอร์ติดต่อ"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.phone}
                    value={formik.values.phone}
                  />
                  {formik.errors.phone && (
                    <FormFeedback>{formik.errors.phone}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>
                    อีเมล<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="email"
                    name="email"
                    placeholder="อีเมล"
                    onChange={formik.handleChange}
                    invalid={!!formik.errors.email}
                    value={formik.values.email}
                  />
                  {formik.errors.email && (
                    <FormFeedback>{formik.errors.email}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>
                    ประเภทหน่วยงานของท่าน<span className="color-red">*</span>
                  </label>
                  <SelectagencyType
                    placeholder="เลือก"
                    name="agencyTypeId"
                    onChange={(e) => {
                      const id = e.nativeEvent.target.selectedIndex;
                      if (id !== "1" && id !== "0" && id !== 1 && id !== 0) {
                        formik.setFieldValue("agencyId", "32");
                      }
                      formik.setFieldValue(
                        "agencyType",
                        e.nativeEvent.target[id].text
                      );
                      formik.setFieldValue("agencyName", "");
                      formik.handleChange(e);
                    }}
                    value={formik.values.agencyTypeId}
                    invalid={!!formik.errors.agencyTypeId}
                    // onBlur={formik.handleBlur}
                  />
                  {formik.errors.agencyTypeId && (
                    <FormFeedback>{formik.errors.agencyTypeId}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label>
                    ชื่อหน่วยงาน<span className="color-red">*</span>
                  </label>
                  <SelectAgency
                    placeholder="เลือก"
                    name="agencyId"
                    onChange={(e) => {
                      const id = e.nativeEvent.target.selectedIndex;
                      if (e.target.value === "32") {
                        formik.setFieldValue("agencyName", "");
                      } else {
                        formik.setFieldValue(
                          "agencyName",
                          e.nativeEvent.target[id].text
                        );
                      }
                      formik.handleChange(e);
                    }}
                    defaultValue={formik.values.agencyId}
                    value={formik.values.agencyId}
                    invalid={!!formik.errors.agencyId}
                    typeId={formik.values.agencyTypeId}
                    disabled={
                      formik.values.agencyTypeId !== "0" &&
                      formik.values.agencyTypeId !== 1 &&
                      formik.values.agencyTypeId !== "1"
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.agencyId && (
                    <FormFeedback>{formik.errors.agencyId}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              {(formik.values.agencyId === "32" ||
                formik.values.agencyId === 32) && (
                <Col md="3">
                  <FormGroup>
                    <label>
                      ชื่อหน่วยงาน<span className="color-red">*</span>
                    </label>
                    <FormInput
                      type="text"
                      placeholder="โปรดระบุ"
                      onChange={formik.handleChange}
                      name="agencyName"
                      invalid={!!formik.errors.agencyName}
                      value={formik.values.agencyName}
                    />
                    {formik.errors.agencyName && (
                      <FormFeedback>{formik.errors.agencyName}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
              )}
              <Col md="3">
                <FormGroup>
                  <label>
                    ตำแหน่ง<span className="color-red">*</span>
                  </label>
                  <FormInput
                    type="text"
                    placeholder="ตำแหน่ง"
                    onChange={formik.handleChange}
                    name="positionName"
                    invalid={!!formik.errors.positionName}
                    value={formik.values.positionName}
                  />
                  {formik.errors.positionName && (
                    <FormFeedback>{formik.errors.positionName}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <FormGroup>
                  <label>
                    จุดประสงค์ในการเข้าใช้งานระบบ
                    <span className="color-red">*</span>
                  </label>
                  <FormTextarea
                    name="purposeAccessingSystem"
                    onChange={formik.handleChange}
                    value={formik.values.purposeAccessingSystem}
                    invalid={!!formik.errors.purposeAccessingSystem}
                    placeholder="จุดประสงค์ในการเข้าใช้งานระบบ"
                  />

                  {formik.errors.purposeAccessingSystem && (
                    <FormFeedback>
                      {formik.errors.purposeAccessingSystem}
                    </FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
          </UserProfilePage>
          <UserProfileFooter>
            <Row>
              <Col md="6"></Col>
              <Col md="3">
                <Button
                  className="btn btn-white w-100"
                  onClick={() => (window.location = "/administrator/users")}
                >
                  {"< กลับ"}
                </Button>
              </Col>
              <Col md="3">
                <Button type="submit" className="btn btn-success w-100">
                  บันทึกข้อมูล
                </Button>
              </Col>
            </Row>
          </UserProfileFooter>
        </Form>
      </Container>
    </>
  );
};

export default AdminUserCreate;
